import React, { Component } from 'react'
import ReceiptLine from './ReceiptLine'
import ReceiptButton from './ReceiptButton'
import { connect } from 'react-redux'
import * as resource from '../constants/Resources'
import * as types from '../constants/Types'
import * as status from '../constants/Status'
import { setReceiptModal } from '../modal/actions/modalActions'
import { getObjectItem, getPriceList, getTranslation } from '../actions/dataActions'
import { setMessageModal } from '../actions/generalActions'
import { reprintReceipt } from '../actions/receiptActions'
import { getSyncCustomer } from '../actions/receiptActions'
import Ink from 'react-ink';
import $ from 'jquery';
import PropTypes from 'prop-types'

class Receipt extends Component {
  constructor(props) {
    super(props);
    this.openReceiptDetails = this.openReceiptDetails.bind(this);
    this.printBlackBoxReceipt = this.printBlackBoxReceipt.bind(this);
    this.showhidereceipt = this.showhidereceipt.bind(this);
  }

  componentDidUpdate() {
    var expander = document.getElementById("expander");
    if (expander) {
      expander.scrollIntoView(false);
    }
  }

  openReceiptDetails() {
    this.props.setReceiptModal(true);
  }

  showhidereceipt() {
    const mainContainer = $('#main-container');
    const receiptKeyboardContainer = $('#receipt-keyboard-container');
    if (receiptKeyboardContainer.css('display') === 'block') {
      mainContainer.css('display', 'block');
      receiptKeyboardContainer.css('display', 'none');
    } else {
      mainContainer.css('display', 'none');
      receiptKeyboardContainer.css('display', 'block');
    }
  }

  printBlackBoxReceipt() {
    let deviceId = 0;
    let posDeviceLinkId = 0;

    this.props.devices.map(device => {
      if (device.printertype === 100
        && device.status === status.PRINTER_OK) {
        deviceId = device.deviceid;
        posDeviceLinkId = device.posdevicelinkid;
      }
      return '';
    });

    if (deviceId > 0
      && posDeviceLinkId > 0) {
      this.props.reprintReceipt(this.props.blackboxReceiptId, deviceId, posDeviceLinkId);
    } else {
      this.props.setMessageModal(true, this.props.getTranslation(resource.NO_WORKING_PRINTER));
    }
  }

  render() {
    let additionalprice = 0;
    const lines = [];
    if (this.props.lines) {
      this.props.lines.map(rec => {
        lines.push(rec);
        if (rec.linetype !== types.SUBTOTAL_LINE) {
          additionalprice += rec.price;
        }
        rec.discount.map(d => {
          additionalprice += d.Price;
          return '';
        })
        return additionalprice;
      })
    }

    const retourButton = (<ReceiptButton key={2} desc={this.props.getTranslation(resource.RETOUR)} type={200} />);
    let stopReceiptButton = '';
    if (!this.props.blackbox) {
      stopReceiptButton = (<ReceiptButton key={1} desc={this.props.getTranslation(resource.STOP_RECEIPT)} type={100} />);
    }

    const closeButton = (<ReceiptButton key={3} desc={this.props.getTranslation(resource.CLOSE_OBJECT)} type={500} />);
    const processButton = (<ReceiptButton key={4} desc={this.props.getTranslation(resource.PROCESS_OBJECT)} type={600} />);

    let footerButtons = {};
    if (this.props.postype === types.POSTYPE_PRODUCTIONKIOSK) {
      footerButtons = (<div className="footer-buttons"><div className="buttons-button">{closeButton}</div><div className="buttons-button">{processButton}</div></div>);
    }
    else {
      footerButtons = (<div className="footer-buttons"><div className="buttons-button">{stopReceiptButton}</div><div className="buttons-button">{retourButton}</div></div>);
    }

    let inputquantity = this.props.inputquantity.split('.').join(',');
    if (this.props.inputquantitynegative) {
      inputquantity = '-'.concat(inputquantity);
    }

    const titleItems = [];
    if (this.props.receiptnumber) {
      titleItems.push(`#${this.props.receiptnumber}`);
    }
    if (this.props.orderNumber) {
      titleItems.push(`(order #${this.props.orderNumber})`);
    }
    if (this.props.pagerNumber && this.props.pagerNumber !== '') {
      titleItems.push(`${this.props.getTranslation(resource.PAGER)} #${this.props.pagerNumber}`);
    }
    if (this.props.objectitemid) {
      const objectItem = this.props.getObjectItem(this.props.objectitemid);
      if (objectItem !== null) {
        titleItems.push(`${objectItem.ItemNumber}`);
      }
    }

    if (this.props.objectitemname && this.props.objectitemname !== '') {
      titleItems.push(`${this.props.objectitemname}`);
    }
    else if (this.props.objectitemdescription) {
      titleItems.push(`${this.props.objectitemdescription}`);
    }

    let title = '';
    titleItems.forEach(item => {
      if (title !== '') {
        title = `${title} - `;
      }
      title = `${title}${item}`;
    })

    let blackboxReprintButton = '';
    if (this.props.blackboxReceiptId > 0) {
      blackboxReprintButton = (<button onClick={this.printBlackBoxReceipt}>
        <i className="print icon red large">&nbsp;</i><Ink />
      </button>)
    }

    let priceListMessage = '';
    if (this.props.customer.customerGroup !== undefined
      && this.props.customer.customerGroup !== null
      && this.props.customer.customerGroup !== '') {
      priceListMessage = `${this.props.customer.customerGroup}`;
    }

    const priceList = this.props.getPriceList(this.props.priceListId);
    if (priceList !== null) {
      if (this.props.customer.customerGroup !== undefined
        && this.props.customer.customerGroup !== null
        && this.props.customer.customerGroup !== '') {
        priceListMessage = `${priceListMessage} - `
      }
      priceListMessage = `${priceListMessage} ${priceList.Description}`;
    }

    let customerMessage = '';
    let saldoMessage = '';
    let receiptAge = this.props.age;
    var customerAge = (receiptAge !== null && receiptAge !== undefined) ? receiptAge : this.props.customer && this.props.customer.age;
    if (customerAge && customerAge !== 0) {
      customerMessage = `${this.props.getTranslation(resource.AGE)}: ${customerAge}`;
    }
    if (this.props.customer.customerid > 0) {
      if (customerMessage.length > 0) {
        customerMessage = `- ${customerMessage}`
      }
      customerMessage = `${this.props.customer.customerName} ${customerMessage}`;
      if (this.props.customer.customerSaldo !== 0.00) {
        saldoMessage = `${this.props.getTranslation(resource.BALANCE)}: ${this.props.customer.customerSaldo.toFixed(2).replace('.', ',')}`;
      }
    }

    let subtotalcontainer = (additionalprice.toFixed(2).replace('.', ','));
    if (this.props.roundAmount) {
      subtotalcontainer = (<div className="subtotalcontainer-roundamount">
        <p>{(Math.round(additionalprice.toFixed(2) * 20) / 20).toFixed(2).replace('.', ',')}</p>
        <p>{additionalprice.toFixed(2).replace('.', ',')}</p>
      </div>);
    }

    let invoiceIcon = '';
    if (this.props.shouldinvoice) {
      invoiceIcon = (<div className="invoice-icon"><i className="payment icon">&nbsp;</i><Ink /></div>);
    }

    let invoiceReference = '';
    if (this.props.shouldinvoice && this.props.invoiceReference) {
      invoiceReference = `${this.props.getTranslation(resource.INVOICE_REFERENCE)}: ${this.props.invoiceReference}`;
    }

    return (
      <div className="receipt-container">
        <div className="receipt-header">
          <div className="header-icon">
            <button className="receipt-details-button" onClick={this.openReceiptDetails}>
              <i className="browser icon">&nbsp;</i><Ink />
            </button>
            <button className="show-hide-receipt-button" onClick={this.showhidereceipt}>
              <i className="content icon">&nbsp;</i><Ink />
            </button>
          </div>
          <div className="header-messagecontainer">
            <div>
              {title}
            </div>
            {priceListMessage && priceListMessage !== '' &&
              <div>
                {priceListMessage}
              </div>
            }
            {customerMessage && customerMessage !== '' &&
              <div>
                {customerMessage}
              </div>
            }
            {saldoMessage && saldoMessage !== '' &&
              <div>
                {saldoMessage}
              </div>
            }
            {
              invoiceReference && invoiceReference !== '' &&
              <div>
                {invoiceReference}
              </div>
            }
          </div>
          <div className="header-icon">
            {invoiceIcon}
            {blackboxReprintButton}
          </div>
        </div>
        <div className="receipt-body">
          {
            lines.map(rec =>
              <ReceiptLine
                key={rec.id}
                lineid={rec.id}
                itemid={rec.itemid}
                description={rec.text}
                configuration={rec.configuration}
                quantity={rec.quantity}
                price={rec.price}
                linetype={rec.linetype}
                editable={rec.editable}
                selected={rec.selected}
                discount={rec.discount}
                weight={rec.weight}
                simpleSeparator={rec.simpleSeparator}
                keyid={rec.keyid}
                productionprinted={rec.productionprinted}
              />
            )
          }
        </div>
        <div className="receipt-footer">
          <div className="footer-price">
            <div className="price-description">
              {this.props.getTranslation(resource.SUB_TOTAL)}
            </div>
            <div className="price-amount">
              {subtotalcontainer}
            </div>
          </div>
          <div className="footer-input">
            {inputquantity}
          </div>
          {footerButtons}
        </div>
      </div>
    )
  }
}

Receipt.propTypes = {
  lines: PropTypes.array,
  inputquantity: PropTypes.string,
  inputquantitynegative: PropTypes.bool,
  receiptnumber: PropTypes.number,
  blackbox: PropTypes.bool
}

function mapStateToProps(state) {
  return {
    lines: state.receiptState.receipt.lines,
    inputquantity: state.receiptState.input.inputquantity,
    inputquantitynegative: state.receiptState.input.inputquantitynegative,
    receiptnumber: state.receiptState.receipt.receiptnumber,
    objectitemid: state.receiptState.receipt.objectitemid,
    objectitemdescription: state.receiptState.receipt.objectitemdescription,
    blackbox: state.generalState.licenses.blackbox && state.generalState.hasBlackbox,
    objectitemname: state.receiptState.receipt.objectitemname,
    devices: state.generalState.devices,
    blackboxReceiptId: state.generalState.licenses.blackboxReceiptId,
    priceListId: state.receiptState.receipt.pricelistid,
    customer: state.receiptState.receipt.customer,
    orderNumber: state.receiptState.receipt.orderNumber,
    pagerNumber: state.receiptState.receipt.pagerNumber,
    defaultPricelistId: state.generalState.defaultPricelistId,
    roundAmount: state.generalState.roundAmount,
    postype: state.generalState.posType,
    shouldinvoice: state.receiptState.receipt.shouldinvoice,
    invoiceReference: state.receiptState.receipt.invoiceReference,
    age: state.receiptState.receipt.age
  }
}

export default connect(mapStateToProps, { setReceiptModal, getObjectItem, setMessageModal, reprintReceipt, getTranslation, getPriceList, getSyncCustomer })(Receipt)



// WEBPACK FOOTER //
// src/components/Receipt.jsx